import React from "react";
import styles from "./NoOfApplicantsComponent.module.scss";

const NoOfApplicantsComponent = ({ applicants, variant }) => {
  const getClassname = () => {
    switch (variant) {
      case "outlined":
        return styles.outlined;

      case "filled":
        return styles.filled;

      default:
        return styles.applicants;
    }
  };

  return (
    <div className={getClassname()}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0007 13.9993C12.0007 12.5849 11.4387 11.2283 10.4386 10.2281C9.43836 9.22792 8.08181 8.66602 6.66732 8.66602C5.25283 8.66602 3.89628 9.22792 2.89608 10.2281C1.89589 11.2283 1.33398 12.5849 1.33398 13.9993"
          stroke="#7C8493"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66732 8.66667C8.50827 8.66667 10.0007 7.17428 10.0007 5.33333C10.0007 3.49238 8.50827 2 6.66732 2C4.82637 2 3.33398 3.49238 3.33398 5.33333C3.33398 7.17428 4.82637 8.66667 6.66732 8.66667Z"
          stroke="#7C8493"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6659 13.3335C14.6659 11.0868 13.3326 9.00013 11.9992 8.00013C12.4375 7.67131 12.788 7.23952 13.0196 6.74298C13.2512 6.24643 13.3569 5.70044 13.3272 5.15333C13.2976 4.60622 13.1335 4.07485 12.8495 3.60626C12.5656 3.13767 12.1705 2.7463 11.6992 2.4668"
          stroke="#7C8493"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      <p>{applicants} Applicant{applicants > 1 && "s"}</p>  
    </div>
  );
};

export default NoOfApplicantsComponent;
